<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search
              v-model="search"
              :disabled="triggerSearch"
              placeholder="Quick Search"
            />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    :disabled="triggerSearch"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status Upload BKM</label>
                  <a-select
                    placeholder="Choose Status "
                    v-model="status"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option key="0" value="0" >No File Uploaded</a-select-option>
                    <a-select-option key="1" value="1" >File Have Been Upload</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="currency">Currency</label>
                  <a-select
                    placeholder="Choose Currency"
                    v-model="currency"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="undefined"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Payment Refund"
        :isMonitoring="true"
        :manifestLink="'RefundPaymentManifestKeu'"
        :dataList="searching"
        :estimasi="false"
        :disabledCreateEditLink="false"
        createLink="createRefundPayment"
        :sisaSaldo="false"
        :informasi="true"
      >
        <template slot="info" slot-scope="data">
          <span class="margin-remove">BKM</span>

          <a-tag
            v-if="data.source.is_uploaded == '1'"
            color="green"
            class="margin-remove"
            style="'width:50%;text-align: center'"
            >File Have Been Uploaded
          </a-tag>
          <a-tag
            v-else
            color="grey"
            class="margin-remove"
            style="'width:50%;text-align: center'"
            >No File Uploaded
          </a-tag>
        </template>
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListOtherOutcome",
  props: ["prnMenu"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      listDirector: [],
      searchDate: null,
      search: "",
      status: undefined,
      currency: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getAllMataUang",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.quickSearch.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getDefaultDateFormat);

        outputData = _.filter(outputData, { tgl_buat: filter });
      }

      if (this.currency) {
        outputData = outputData.filter(
          (obj) =>
            obj.currency &&
            obj.currency.toLowerCase().indexOf(self.currency.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.is_uploaded && obj.is_uploaded.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
  },
  created() {
    this.fetchData();
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
  },
  mounted() {
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
  },
  methods: {
    moment,
    fetchData() {
      // monitoring/klaim_direktur
      // id: localStorage.getItem("nvky"),
      this.loading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "payment_refund",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        _.forEach(response.data.data, (data) => {
          this.dataList.push({
            // status: data.edit_sts == 1 ? "Revised" : "",
            // status_besar: data.status_besar,
            // edit_sts: data.edit_sts,
            title: data.no_trans+" | "+data.pembuat,
            subtitle: data.jenis+" | "+data.no_po_wo,
            subdesc: [
              "From : "+data.from,
              "To : "+data.nama_bank+" ("+data.kode_rekening+")",
              "Desc : "+data.description,
              [
                {
                  label: "Create Date",
                  value: this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat),
                },
              ],
              [
                {
                  label: "Value Refund",
                  value: this.formatCurrency(data.currency_refund,data.value_refund),
                },
              ],
              [
                {
                  label: "Value Receive",
                  value: this.formatCurrency(data.currency_receive,data.value_receive),
                },
              ],
            ],
            //timeline: JSON.parse(data.workflow_status),
            id: data.refund_payment_id,
            is_uploaded: data.bkm=='File Has Been Uploaded' ? "1" : "0",
            closeStatus: data.close_sts == "1" ? "Close" : "",
            cancelStatus: data.cancel_sts
              ? data.cancel_sts == "1"
                ? "Canceled"
                : null
              : null,
            tlc_create: data.tlc_create,
            currency: data.currency_origin,
            tgl_buat: this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat),
            quickSearch:
              data.no_trans+" | "+data.pembuat +
              " " +
              data.jenis+" | "+data.no_po_wo +
              " " +
              data.from +
              " " +
              data.nama_bank+" ("+data.kode_rekening+")" +
              " " +
              data.description +
              " " +
              this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat)
              + "" +
              this.formatCurrency(data.currency_origin,data.value_refund)
              + "" +
              this.formatCurrency(data.currency_origin,data.value_trans),
          });
        });

        this.loading = false;
      });
    },
    clickTabed(val) {
      this.search = "";
      this.searchDate = undefined;
      this.currency = undefined;
      this.status = undefined;
      if (val == "draft") {
        this.triggerSearch = true;
      } else {
        this.triggerSearch = false;
      }
    },
  },
};
</script>

<style></style>
